export default __webpack_public_path__ + "img/img_jeff-3c65b37eea7a2c66064cb6a0195ddc8b.jpg";